import { lists_type } from "../interfaces";

export const lists: lists_type = {
  globalAdmin_console: [
    // // { url: "/workspaces", kind: "workspaces", no_info: true },
    // { url: "/nodes", kind: "nodes" },
    // // { url: "/servicecomponents", kind: "service_components" },
  ],
  datacenterAdmin_console: [
    // { url: "/workspaces", kind: "workspaces", no_info: true },
    { url: "/nodes", kind: "nodes" },
    // { url: "/servicecomponents", kind: "service_components" },
  ],
  clusterAdmin_console: [
    // { url: "/info", kind: "cluster_info" },
    // // { url: "/workspaces", kind: "workspaces", no_info: true },
    // { url: "/nodes", kind: "nodes" },
    // // { url: "/servicecomponents", kind: "service_components" },
  ],
  clusterOwner_console: [
    { url: "/info", kind: "cluster_info" },
    // { url: "/workspaces", kind: "workspaces", no_info: true },
    { url: "/nodes", kind: "nodes" },
    // { url: "/servicecomponents", kind: "service_components" },
  ],
  workspaceOwner_console: [
    // { url: "/workspaces", kind: "workspaces" },
    // { url: '/namespaces', kind: 'namespaces' },
  ],
  namespaceDeveloper_console: [{ url: "/namespaces", kind: "namespaces" }],
  clusters_page: [],
  cluster_overview_page: [],
  nodes_page: [],
  workspacequotas_page: [],
  namespacequotas_page: [],
  workspace_scale_page: [
    { url: "/workspaces", kind: "workspaces", no_info: true },
    { url: "/workspacequotas", kind: "workspacequotas" },
  ],
  namespace_scale_page: [{ url: "/workspaces", kind: "workspaces", no_info: true }],
  roles_page: [{ url: "/v1/roles", kind: "roles", no_datacenter: true }],
  workspaces_page: [],
  workspace_overview_page: [],
  namespaces_page: [],
  namespace_overview_page: [],
  workloads_page: [],
  monitor_page: [
    { url: "/api/search", kind: "monitor_tag_folder", no_datacenter: true },
    { url: "/api/search", kind: "monitor_dbs", no_datacenter: true },
  ],
  monitor: [],
  applications_page: [],
  app_workload: [],
  ingress_page: [],
  pod_restart_aralm: [],
};
